import { apiClient } from './api';

// Get solution proposal data
export const getSolutionProposal = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/solution-proposal`);
    return response.data;
  } catch (error) {
    console.error('Error fetching solution proposal:', error);
    throw error;
  }
};

// Update solution details
export const updateSolutionDetails = async (projectId, data) => {
  try {
    const response = await apiClient.post(
      `/projects/${projectId}/solution-proposal/solution-details`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error updating solution details:', error);
    throw error;
  }
};

// Generate solution proposal with AI
export const generateSolutionProposal = async (projectId) => {
  try {
    const response = await apiClient.post(
      `/projects/${projectId}/solution-proposal/generate`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error('Error generating solution proposal:', error);
    
    // Extract error message from the response if available
    if (error.response && error.response.data && error.response.data.message) {
      error.userMessage = error.response.data.message;
    } else {
      error.userMessage = 'Error generating solution proposal. Please check if project documents are attached to this project.';
    }
    
    throw error;
  }
};

// Export solution proposal as DOCX
export const exportDocx = async (projectId) => {
  try {
    const response = await apiClient.get(
      `/projects/${projectId}/solution-proposal/export/docx`
    );
    
    if (!response.data || !response.data.document_path) {
      console.warn('Document path is missing in the response:', response.data);
    }
    
    return response.data;
  } catch (error) {
    console.error('Error exporting document:', error);
    // Check if it's a 404 error, which indicates the resource wasn't found
    if (error.response && error.response.status === 404) {
      throw new Error('The export endpoint was not found. Please contact support.');
    }
    // Extract message from the response if available
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};

// Export solution proposal as PDF
export const exportPdf = async (projectId) => {
  try {
    const response = await apiClient.get(
      `/projects/${projectId}/solution-proposal/export/pdf`
    );
    
    if (!response.data || !response.data.document_path) {
      console.warn('Document path is missing in the response:', response.data);
    }
    
    return response.data;
  } catch (error) {
    console.error('Error exporting PDF:', error);
    // Check if it's a 404 error, which indicates the resource wasn't found
    if (error.response && error.response.status === 404) {
      throw new Error('The export endpoint was not found. Please contact support.');
    }
    // Extract message from the response if available
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};